import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useMemo,
} from 'react';
import classNames from 'classnames';
import { Button, Modal } from 'ncoded-component-library';
import useCallbackRef from 'hooks/useCallbackRef';
import { Field, Form } from 'react-final-form';
import SelectField from 'components/SelectField';
import { DataRoomNdaSigning } from 'router/subrouters/DataRoom/models/DataRoomNDA';
import { useTranslation } from 'react-i18next';
import { OverlayRef } from 'ncoded-component-library/build/components/atoms/Overlay/Overlay.component';

import './DataRoomChooseNdaModal.styles.scss';

type DataRoomChooseNdaModalProps = {
  className?: string;
  signings: DataRoomNdaSigning[];
  onSigningSelect?: (signingId: string) => void;
};

const DataRoomChooseNdaModal: ForwardRefRenderFunction<
  OverlayRef,
  DataRoomChooseNdaModalProps
> = (props, ref) => {
  const { className, signings = [], onSigningSelect } = props;

  const classes = classNames('data-room-choose-nda-modal', className);

  const [modal, modalRef] = useCallbackRef<OverlayRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const { t } = useTranslation();

  const signingsOptions = useMemo(
    () =>
      signings.map(({ _id, dataRoomNda }) => ({
        value: _id,
        label: dataRoomNda.name,
      })),
    [signings],
  );

  return (
    <Modal ref={modalRef} title={t('selectNda')} className={classes}>
      <Form
        onSubmit={({ signingId }) => onSigningSelect(signingId)}
        render={({ values, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Field
              name="signingId"
              options={signingsOptions}
              component={SelectField}
            />

            <div className="actions">
              <Button variant="link" onClick={modal?.close}>
                {t('close')}
              </Button>
              <Button type="submit" disabled={!values.signingId}>
                {t('select')}
              </Button>
            </div>
          </form>
        )}
      />
    </Modal>
  );
};

export default forwardRef(DataRoomChooseNdaModal);
